import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Form, Input } from 'antd'
import { useTheme } from 'antd-style'

export const FormNomenclaturesTags = () => {
  const { t } = useLocales()
  const theme = useTheme()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="color"
        label={t('nomenclature.color')}
        rules={[{ required: true }]}
        getValueFromEvent={(color) => color.toHexString()}
        initialValue={theme.colorPrimary}
      >
        <FormColorPicker
          itemProps={{
            label: t('nomenclature.color')
          }}
          showText
        />
      </Form.Item>
    </>
  )
}
